const TIMELINE_INJECTION_KEY = "timeline";

export { TIMELINE_INJECTION_KEY };
//# sourceMappingURL=tokens.mjs.map
